import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Center from '@zenbusiness/zui/Center';
import Heading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { FocusGrid, ContainerGrid } from '#client/components/Grid';
import { BASE_URL } from '#client/constants/url';
import useBreakpoints from '#client/hooks/useBreakpoints';

import { DialogContentStyled, Wrapper } from './DialogAndWrapper.styles';

export function AccountCouldNotSetUp() {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <DialogContentStyled>
      <ContainerGrid>
        <FocusGrid>
          <Wrapper gap={{ xs: '64px', md: '80px' }}>
            <Center>
              <Box>
                <SharedAsset
                  alt=""
                  height={isDesktop ? 200 : 110}
                  src="/s2/vector/alert-green-iso.svg"
                  width={isDesktop ? 200 : 110}
                />
              </Box>
              <Stack
                gap="8px"
                mt={{ xs: '24px', md: '40px' }}
              >
                <Heading
                  align="center"
                  family="secondary"
                  size={isDesktop ? '3xl' : '2xl'}
                  weight="bold"
                >
                  Your account could not be set up for instant deposit
                </Heading>
                <Text
                  align="center"
                  size="md"
                >
                  We’re sorry for the inconvenience. Contact our team to learn more.
                </Text>
              </Stack>
              <Stack
                mt={{ xs: '32px', md: '40px' }}
                sx={{ width: isDesktop ? 'auto' : '100%' }}
              >
                <Button
                  href={`${BASE_URL}/contact-us/`}
                  target="_blank"
                  variant="contained"
                >
                  Contact us
                </Button>
              </Stack>
            </Center>
          </Wrapper>
        </FocusGrid>
      </ContainerGrid>
    </DialogContentStyled>
  );
}
